"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = require("classnames");
var ButtonContent_1 = require("./ButtonContent");
var styles_1 = require("./styles");
var Button = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'button' : _b, _c = _a.variant, variant = _c === void 0 ? 'primary' : _c, onClick = _a.onClick, dataTestId = _a["data-testid"], _d = _a.size, size = _d === void 0 ? 'sm' : _d, className = _a.className, leftIcon = _a.leftIcon, leftIconSize = _a.leftIconSize, leftIconOutlined = _a.leftIconOutlined, rightIcon = _a.rightIcon, rightIconSize = _a.rightIconSize, rightIconOutlined = _a.rightIconOutlined, active = _a.active, children = _a.children, forwardedRef = _a.forwardedRef, branding = _a.branding, otherProps = __rest(_a, ["type", "variant", "onClick", 'data-testid', "size", "className", "leftIcon", "leftIconSize", "leftIconOutlined", "rightIcon", "rightIconSize", "rightIconOutlined", "active", "children", "forwardedRef", "branding"]);
    var buttonVariant = (0, styles_1.useButtonVariantStyle)({
        variant: variant,
        disabled: otherProps.disabled,
        active: active,
        branding: branding,
    });
    var labelClasses = (0, styles_1.useLabelStyle)({
        variant: variant,
        disabled: otherProps.disabled,
        active: active,
        branding: branding,
    });
    var iconPosition = 'left';
    if (leftIcon && rightIcon) {
        iconPosition = 'both';
    }
    else if (rightIcon) {
        iconPosition = 'right';
    }
    var buttonSize = (0, styles_1.sizeStyle)(size, {
        hasIcon: !!leftIconSize || !!rightIconSize,
        position: iconPosition,
    });
    return ((0, jsx_runtime_1.jsx)("button", __assign({}, otherProps, { type: type, onClick: onClick, className: classnames_1.default.apply(void 0, __spreadArray(__spreadArray(__spreadArray(['squid-flex',
            'squid-justify-center',
            'squid-items-center',
            'squid-border',
            'focus:squid-outline-none',
            'squid-ring-offset-2',
            'focus-visible:squid-ring'], buttonVariant, false), buttonSize, false), [labelClasses,
            className], false)), "data-testid": dataTestId, ref: forwardedRef }, { children: (0, jsx_runtime_1.jsx)(ButtonContent_1.default, __assign({ labelSize: size, leftIcon: leftIcon, rightIcon: rightIcon, rightIconSize: rightIconSize, leftIconSize: leftIconSize, leftIconOutlined: leftIconOutlined, rightIconOutlined: rightIconOutlined, labelClasses: labelClasses }, { children: children })) })));
};
exports.Button = Button;
